export const IMAGE_LAYER_ACCEPT = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'].join(', ');
